<div class="container">
    <div class="row">
        
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Taller</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a routerLink="/servicio-tecnico/agendar-cita" class="text-uppercase ff-medium" (click)="cerrarMenu()">Agendar Cita</a>
                        </li>
                    </ul>
                </div>
            
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Repuestos</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://www.toyosa.com/tienda-virtual/repuestos/yamaha" target="_blank" class="text-uppercase ff-medium" (click)="cerrarMenu()">Tienda en línea</a>
                        </li>
                    </ul>
                </div>
            
    </div>
</div>
